// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Navbar_Wrapper__19ESz","Navbar":"Navbar_Navbar__26d5F","Menu":"Navbar_Menu__107gB","Logo":"Navbar_Logo__r_qLg","Btn":"Navbar_Btn__38Gtm"};